export const persistSurveySession = (
  {
    instance,
    token,
  },
  storage = localStorage
) => {
  if (!instance || !token) return false;

  storage.setItem("instance", instance);
  storage.setItem("token", token);
  return true;
};
